import React from "react";
import s from "./DiseaseButtons.module.scss";
import { Link, useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getDiseaseDetails,
  getKazakhstanDiseaseDetails,
  getOtherCountriesDeportationDetails,
  getPreDepartureDiseaseDetails,
} from "../../redux/InformationSlice";

export interface IDisease {
  button: string;
  id: number;
  button_ru: string;
  button_kg: string;
  button_uz: string;
  button_tj: string;
}

interface Props {
  diseases: IDisease[] | undefined;
  country: string;
}

const DiseaseButtons: React.FC<Props> = ({ diseases, country }) => {
  const dispatch: AppDispatch = useDispatch();
  const params = useParams();
  const lang = useSelector((state: RootState) => state.info.lang);

  const getPath = (button: string, id: number) => {
    if (country === "russia") {
      switch (button) {
        case "ВИЧ":
          return `/russia/hiv/${id}`;
        case "Сифилис":
          return `/russia/syphilis/${id}`;
        case "Туберкулёз":
          return `/russia/tuberculosis/${id}`;
        case "Психоактивные вещества":
          return `/russia/pas/${id}`;

        case "Для мигрантов, живущих с ВИЧ":
          return `/russia/pre-departure/hiv/${id}`;
        case "Для мигрантов с диагнозом сифилис":
          return `/russia/pre-departure/syphilis/${id}`;
        case "Для мигрантов с диагнозом туберкулез":
          return `/russia/pre-departure/tuberculosis/${id}`;
        case "Для мигрантов, употребляющих психоактивные вещества":
          return `/russia/pre-departure/pas/${id}`;
        default:
          return `/russia`;
      }
    }
    if (country === "kazakhstan") {
      switch (button) {
        case "Для мигрантов, живущих с ВИЧ":
          return `/kazakhstan/hiv/${id}`;
        case "Для мигрантов с диагнозом сифилис":
          return `/kazakhstan/syphilis/${id}`;
        case "Для мигрантов с диагнозом туберкулез":
          return `/kazakhstan/tuberculosis/${id}`;
        case "Для мигрантов, употребляющих психоактивные вещества":
          return `/kazakhstan/pas/${id}`;
        default:
          return `/kazakhstan`;
      }
    }
    if (country === "otherCountries") {
      switch (button) {
        case "Страны, которые депортируют иностранцев с ВИЧ-положительным статусом":
          return `/otherCountries/deportation/${id}`;
        case "Советы для людей, живущих с ВИЧ, при поездках и миграции":
          return `/otherCountries/advises/${id}`;
        default:
          return `/otherCountries`;
      }
    }
    return "/";
  };
  const handleClick = (button: string, id: number) => {
    if (country === "russia") {
      if (
        button.includes("У меня") ||
        button.includes("pre-departure") ||
        button.includes("Я")
      ) {
        dispatch(getPreDepartureDiseaseDetails(id));
      } else {
        dispatch(getDiseaseDetails(id));
      }
    }
    if (country === "kazakhstan") {
      dispatch(getKazakhstanDiseaseDetails(id));
    }

    if (country === "otherCountries") {
      dispatch(getOtherCountriesDeportationDetails(id));
    }
  };

  return (
    <div className={country === "otherCountries" ? s.twoButtons : s.buttons}>
      {diseases?.map((it) => (
        <Link
          to={getPath(it?.button, it.id)}
          className={s.btn}
          onClick={() => handleClick(it.button, it.id)}
        >
          {it[`button_${lang}`]}
        </Link>
      ))}
    </div>
  );
};

export default DiseaseButtons;
